<template>
  <v-dialog
    max-width="400"
    :value="true"
    @click:outside="$emit('cancel')"
  >
    <v-card>
      <v-card-title>
        <h2>Product Discount</h2>
      </v-card-title>

      <v-card-text>
        <v-text-field v-model="discount" solo />
      </v-card-text>

      <v-card-actions>
        <button
          class="default-btn blue"
          @click="$emit('submit', discount)"
        >Save Discount</button>

        <button class="default-btn text" @click="$emit('cancel')">Cancel</button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogUpdateDiscount',
  props: {
    existingDiscount: String,
  },

  data: () => ({
    discount: '',
  }),

  created () {
    this.discount = this.existingDiscount || ''
  },
}
</script>

<style lang="scss" scoped></style>
